import { useEffect, useState } from 'react';
import { useAirKeyTrace } from '@/utils/airKeyTrace';
import warningIcon from '@assets/Caution.svg';
import { useBowserParser } from '@hooks/useBowserParser';

export const NotSupported = () => {
  const [actionSent, setActionSent] = useState(false);
  const bowserObj = useBowserParser();
  const sendTrace = useAirKeyTrace();

  useEffect(() => {
    if (!bowserObj.loading && !actionSent) {
      sendTrace({
        view: 'browser_not_supported',
        action: 'view_loaded',
        additionalData: {
          bowser: bowserObj,
        },
      });
      setActionSent(true);
    }
  }, [bowserObj, actionSent]);

  return (
    <div className="not-supported-dialog" data-testid="NotSupported">
      <img src={warningIcon} width="66" alt="" role="presentation" />
      <h3>There was an issue</h3>
      <div className="text-center">
        The device or browser you are using does not support AirKey taps. Return
        to the merchant and choose a different form of identity for
        verification.
      </div>
    </div>
  );
};
